import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit a premises (an area inside the central location). self-saving.
@Component({
  selector: 'app-cc-premises-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './cc-premises-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcPremisesDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  isEdit: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CcPremisesDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: { premises?: any; organisations: any[] }
  ) {
    const row = this.data?.premises;
    this.isEdit = !!row;
    this.form = this.fb.group({
      orgId: [row?.orgId || '', Validators.required],
      name: [row?.name || '', Validators.required],
      abbrevName: [row?.abbrevName || '', Validators.required],
      address: [row?.address || '', Validators.required],
      contactNumber: [row?.contactNumber || '', Validators.required],
      altContactNumber: [row?.altContactNumber || ''],
      status: [row?.status || 'ACTIVE', Validators.required],
      distanceRank: [row?.distanceRank ?? ''],
      comments: [row?.comments || ''],
    });
  }

  get title(): string {
    return this.isEdit ? 'Edit premises' : 'Add premises';
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Organisation, name, short name, address and contact are required.');
      return;
    }
    this.isLoading = true;
    const payload = this.form.value;
    const request = this.isEdit
      ? this.catalogueService.updatePremises(this.data.premises.premisesId, payload)
      : this.catalogueService.addPremises(payload);

    request.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save the premises.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
